import createVueApp from '@/common/createApp'
import { useMediaScheduleShowStore } from '@/stores/mediaScheduleShow'

Styxie.Initializers.MediaSchedules = {
  index: async(props) => {
    const { default: MediaSchedulesIndex } = await import('@/vue_widgets/media_schedules/index.vue')
    createVueApp(MediaSchedulesIndex, { props })
  },
  show: async({ params }) => {
    const { default: MediaScheduleShow } = await import('@/vue_widgets/media_schedules/show/index.vue')
    createVueApp(MediaScheduleShow, { state: (pinia) => useMediaScheduleShowStore(pinia).initialize(params) })
  }
}
